import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';

const WebViewerElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Web Viewer',
  icon: 'DocumentIcon',
  description:
    'Adds a Web Viewer to the Screen to view a Web Page inside the app',
  properties: [
    'height',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Markup',
      name: 'datasourceFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Url',
      name: 'url',
      editor: 'textbox',
      default: 'http://www.google.com',
      options: [],
      displayWhen: [{ field: 'datasourceId', operator: 'IS_EMPTY', value: '' }],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default WebViewerElementFields;
